module.exports = __webpack_public_path__ + "media/images/faces/female/04-2e4a2e74109099d2ba7a747836cf564a.jpg";